var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "search-btn-hide": true,
          "label-position": _vm.labelPosition,
          "is-list": true,
          "label-width": "80px",
          "col-span": _vm.colSpan,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("screenWMS.waveId") + " :" } },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            disabled: "",
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("screenWMS.waveId"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.waveId,
                            callback: function ($$v) {
                              _vm.waveId = $$v
                            },
                            expression: "waveId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("screenWMS.Status") + " :" } },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            disabled: "",
                            "option-list": _vm.WAVE_STATUS_LIST,
                            placeholder: _vm.$t("screenWMS.Status"),
                          },
                          model: {
                            value: _vm.status,
                            callback: function ($$v) {
                              _vm.status = $$v
                            },
                            expression: "status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("screenWMS.creation") + " :" } },
                      [
                        _c("BjDateTimerPicker", {
                          attrs: {
                            disabled: "",
                            "tip-show": false,
                            placeholder: _vm.$t("screenWMS.creation"),
                          },
                          model: {
                            value: _vm.creationDate,
                            callback: function ($$v) {
                              _vm.creationDate = $$v
                            },
                            expression: "creationDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("screenWMS.completion") + " :" },
                      },
                      [
                        _c("BjDateTimerPicker", {
                          attrs: {
                            disabled: "",
                            "tip-show": false,
                            placeholder: _vm.$t("screenWMS.completion"),
                          },
                          model: {
                            value: _vm.completionTime,
                            callback: function ($$v) {
                              _vm.completionTime = $$v
                            },
                            expression: "completionTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("screenWMS.sortingStation") + " :",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            disabled: "",
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("screenWMS.sortingStation"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.sortingStation,
                            callback: function ($$v) {
                              _vm.sortingStation = $$v
                            },
                            expression: "sortingStation",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.seeHistory },
                      },
                      [_vm._v(_vm._s(_vm.$t("screenWMS.history")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.printAll },
                      },
                      [_vm._v(_vm._s(_vm.$t("screenWMS.PrintAll")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "orderId"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goInnerDetail(
                                                    scope.row.innerOrderNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "hjStatus"
                                      ? [
                                          scope.row.hjStatus == 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "InternalSalesOrderDetails.Completed"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          scope.row.hjStatus == 0
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "InternalSalesOrderDetails.Incomplete"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onPrint(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("screenWMS.Print"))
                                        ),
                                      ]
                                    ),
                                    props.row.status != "skip"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSkip(props.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("screenWMS.Skip"))
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unSkip(props.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("screenWMS.unSkip"))
                                            ),
                                          ]
                                        ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled: props.row.hjStatus == 1,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.closeOrder(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("screenWMS.close"))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("AllHistory", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleAllHistory,
            expression: "visibleAllHistory",
          },
        ],
        ref: "AllHistory",
        attrs: { width: "850px", visible: _vm.visibleAllHistory },
        on: {
          close: function ($event) {
            _vm.visibleAllHistory = false
          },
        },
      }),
      _c("viewDialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleViewDialog,
            expression: "visibleViewDialog",
          },
        ],
        ref: "viewDialog",
        attrs: { width: "850px", visible: _vm.visibleViewDialog },
        on: {
          close: function ($event) {
            _vm.visibleViewDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }